import { ActivityLinkHydration } from '../../../shared/modules/activity/dtos/activity-link-hydration.dto';

/**
 * Resolved related records for a customer activity event, keyed by relation.
 */
export class CustomerActivityEventHydration {
  link?: ActivityLinkHydration;
}
